module.exports = __webpack_public_path__ + "static/media/screen-supply-chain.8b0ba352.png";